import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, message, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { useGetDataOnScroll } from "../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { EntPersonellFilter } from "../../../models/filters/personellFilter";
import { usePersonnel } from "./usePersonnel";
import { useTranslation } from "react-i18next";
import {
  useLazyGetPersonnelListFilteredQuery,
  useReportPersonnelMutation
} from "../../../redux/api/mechanization/personnelApi";
import { EmptyData } from "../../../components/empty/emptyData";
import { PageHeader } from "../../../components/page-header";
import { ContentPartFilter } from "../../../components/content-part/ContentPartFilter";
import { AddPersonnelModal } from "./AddPersonnelModal";
import { FilterPersonel } from "./FilterPersonel";
import { EntPersonnelItem } from "../../../models/personnelItem";
import i18n from "i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/root/root-state.interface";
import dayjs from "dayjs";


enum FormField {
  periodStart,
  periodEnd,
  governmentIds
}

export const Personel = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntPersonnelItem>(new EntPersonnelItem());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()
  const authState = useSelector((state: RootState) => state.authSlice);

  const [getReportPersonnel] = useReportPersonnelMutation();
  const [getArchiveFolders] = useLazyGetPersonnelListFilteredQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntPersonnelItem, EntPersonellFilter>({
	initialFilter: new EntPersonellFilter(),
	query: getArchiveFolders
  });
  const { onAddPersonnel, onEditPersonnel, onDeletePersonnel } = usePersonnel(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntPersonnelItem) => {
	setSelectedItem(item);
	setShowModal(true);
  }
  const setEntityFromFieldsFilter = (): EntPersonellFilter => {
	let filt: EntPersonellFilter = _.clone(filter);
	filt.periodStart = form.getFieldValue(FormField.periodStart) ?? null;
	filt.periodEnd = form.getFieldValue(FormField.periodEnd) ?? null;
	filt.governmentIds = form.getFieldValue(FormField.governmentIds) ?? null;
	filt.page = 1;
	return filt;

  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.periodStart, value: null },
	  { name: FormField.periodEnd, value: null },
	  { name: FormField.governmentIds, value: null },
	]);
  }
  const searchHandleClick = () => {
	setFilter(setEntityFromFieldsFilter());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const handleSubmit = async () => {
	try {
	  const payload = {
		governmentAlias: authState.governmentAlias,
		language: i18n.language,
	  };

	  const result = await getReportPersonnel(payload);

	  if ('data' in result) {
		const blob = result.data;
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", `Report_${ dayjs().format("YYYY-MM-DD") }.xlsx`);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		message.success(t('reports.download_success'));
	  } else {
		throw new Error(t('reports.download_failed'));
	  }
	} catch (error: any) {
	  Modal.error({
		title: t("msg.error"),
		content: error.message || t('reports.download_failed'),
	  });
	}
  };


  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.start_date_period') }</th>
		  <th>{ t('general.end_date_period') }</th>
		  <th>Политическая должность</th>
		  <th>Гос должность</th>
		  <th>не Гос должность</th>
		  <th>ТОП</th>
		  <th>МОП</th>
		  <th>Другие</th>
		  <th>Прибывшие</th>
		  <th>Убывшие</th>
		  <th>Организация</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.periodStart } </td>
			<td>{ item.periodEnd } </td>
			<td>{ item.countPolitical } </td>
			<td>{ item.countAdministrative } </td>
			<td>{ item.countNonState } </td>
			<td>{ item.countTop } </td>
			<td>{ item.countMiddle } </td>
			<td>{ item.countOther } </td>
			<td>{ item.countArrived } </td>
			<td>{ item.countDeparted } </td>
			<td>{ item.government?.nameRu } </td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeletePersonnel(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : <tr>
		  <td colSpan={ 12 }>
			<EmptyData/>
		  </td>

		</tr> }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.personnel') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntPersonnelItem)
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  { isReportAvailable && (
		<Button style={ { marginLeft: '5px' } } type="primary" icon={ <PlusOutlined/> }
				onClick={ () => handleSubmit() }>
		  { t('reports.download_report') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterPersonel onSearch={ searchHandleClick }
								 onReset={ () => {
								   clearFields();
								   searchHandleClick()
								 } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddPersonnelModal
		personal={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditPersonnel : onAddPersonnel }
	  />
	  { contextHolder }
	</>
  )
}
